// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import DrivingLicenceActionType from './driving-licence-details.types';

const INITIAL_STATE = {
	// Update Driving Licence Response
	updateDrivingLicenceResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** UPDATE DRIVING LICENCE REDUCER START *********************** */
		case DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_SUCCESS:
			return { ...state, updateDrivingLicenceResponse: action.payload };

		case DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_FAILURE:
			return { ...state, updateDrivingLicenceResponse: action.payload };

		case DrivingLicenceActionType.UPDATE_DRIVING_LICENCE_RESPONSE_CHANGED:
			return { ...state, updateDrivingLicenceResponse: null };

		default:
			return state;
	}
};
/** ***************** UPDATE DRIVING LICENCE REDUCER END *********************** */
